// extracted by mini-css-extract-plugin
var _1 = "OrganizationOnboardingStepTeam-module__logoEditorContainer--cg8VU";
export { _1 as "logoEditorContainer" }
